import React, { useEffect, useState } from "react";
import { Button, Input, Space, Tag, Empty } from "antd";
import axios from "../../requests/axios";
import routes from "../../requests/routes";
import { Link } from "react-router-dom";
import classes from "./CapacityProjects.module.scss";

import { parseDate } from "../../utils/utils";
import { FaRegClock } from "react-icons/fa";
import { FaArrowRightLong } from "react-icons/fa6";
import CapacityHero from "./CapacityHero/CapacityHero";
import OptimizedImage from "../../components/OptimizedImage";

export default function CapacityProjects() {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(12);
  const [total, setTotal] = useState(0);

  const fetchList = async ({ pageArg = page, sizeArg = pageSize } = {}) => {
    try {
      setLoading(true);
      const { data } = await axios.get(routes.capacityPublicList, {
        params: { q: q?.trim() || undefined, page: pageArg, limit: sizeArg },
      });

      const list = data?.projects || [];
      const totalCount =
        Number(
          data?.total ?? data?.count ?? data?.paging?.total ?? data?.totalCount
        ) || 0;
      const limitFromApi =
        Number(data?.limit ?? data?.paging?.limit ?? data?.pageSize) || sizeArg;

      setRows(Array.isArray(list) ? list : []);
      setTotal(totalCount);
      setPageSize(limitFromApi);
    } catch (e) {
      console.warn("Capacity list error:", e?.message);
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchList();
  }, [page, pageSize]);

  const onSearch = () => {
    setPage(1); // trigger useEffect to refetch with q
    fetchList({ pageArg: 1, sizeArg: pageSize });
    const el = document.getElementById("projects-list");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <CapacityHero />
      <div className={classes.capacity_building}>
        {/* HERO */}
        {/* GRID */}
        <div
          id="projects-list"
          className={classes.capacity_building__container}
        >
          <div className={classes.capacity_building__container__head}>
            <div className={classes.capacity_building__container__head__title}>
              Projects ({rows.length})
            </div>
            <Space>
              <Input
                placeholder="Search projects…"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                onPressEnter={onSearch}
                allowClear
              />
              <Button type="primary" onClick={onSearch}>
                Search
              </Button>
            </Space>
          </div>
          {rows.length === 0 && !loading ? (
            <Empty description="No projects found" />
          ) : (
            <div className={classes.projects}>
              {(rows || []).map((p) => (
                <div className={classes.projects__card_wrapper}>
                  <Link to={`/capacity-projects/${p.slug || p._id}`}>
                    <div>
                      {p.bannerImage ? (
                        // <img
                        //   src={p.bannerImage}
                        //   className={classes.projects__card_wrapper__banner}
                        //   alt={p.name + " banner"}
                        //   style={{
                        //     height: 160,
                        //     objectFit: "cover",
                        //     width: "100%",
                        //   }}
                        // />
                        <OptimizedImage
                          alt={p.name + " banner"}
                          className={classes.cb_banner}
                          sources={[
                            {
                              type: "image/jpeg",
                              srcSet: p.bannerImage,
                            },
                          ]}
                          fallback={{
                            src: "../../assets/imgs/notFound/fallback-image.png",
                          }}
                        />
                      ) : (
                        <div style={{ height: 160, background: "#f5f5f5" }} />
                      )}

                      {p.logo ? (
                        <img
                          className={classes.projects__card_wrapper__logo}
                          src={p.logo}
                          alt={p.name}
                        />
                      ) : null}
                      <div className={classes.projects__card_wrapper__content}>
                        <p
                          className={
                            classes.projects__card_wrapper__content__name
                          }
                        >
                          {p.name}
                        </p>

                        <div>
                          {p.programName && <Tag>{p.programName}</Tag>}
                          {p.type && <Tag color="blue">{p.type}</Tag>}
                        </div>
                      </div>
                      <div className={classes.projects__card_wrapper__footer}>
                        <div className={classes.time}>
                          <FaRegClock size={16} />
                          {parseDate(p.startDate)}
                          {"  to  "}
                          {parseDate(p.endDate)}
                        </div>
                        <Link className={classes.more}>
                          View More
                          <FaArrowRightLong />
                        </Link>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          )}

          {/* <div
      style={{ display: "flex", justifyContent: "center", marginTop: 16 }}
    >
      <Pagination
        current={page}
        pageSize={pageSize}
        total={total}
        showSizeChanger
        pageSizeOptions={["6", "12", "24", "48"]}
        onChange={(p, ps) => {
          setPage(p);
          setPageSize(ps);
          // smooth scroll back to list on page change
          const el = document.getElementById("projects-list");
          if (el) el.scrollIntoView({ behavior: "smooth" });
        }}
        disabled={loading}
      />
    </div> */}
        </div>
      </div>
    </>
  );
}
